
<div *ngIf="isValidIndicator()" class="validation-message icon-system_error" [ngbPopover]="tooltip" triggers="click hover" container="body" popoverClass="validation-error"></div>
<span>{{params.valueFormatted}}</span>

<ng-template #tooltip>
  <div class="message-text">
    <p>{{"plan.dist.cell.validation.line1"|translate}}<br>
      {{"plan.dist.cell.validation.line2"|translate}}<br>
      <br>
      <b>{{"plan.dist.cell.validation.line3"|translate}}{{validationSum}}%</b></p>
  </div>
</ng-template>
